import React, { useMemo } from 'react';
import i18n from 'i18next';

import { CdnIcon } from '@shared/ui';

import { Sorting } from '../../../../enums';
import { ListOption } from '@shared/ui';

const sortings = [Sorting.Price, Sorting.FlightTime, Sorting.Departure, Sorting.Arrival];

const getSortingLabels = (sorting: Sorting) => {
	const sortingLabels: Partial<{ [key in Sorting]: { label: string; icon: React.ReactNode } }> = {
		[Sorting.Price]: {
			label: i18n.t('Results:Price'),
			icon: <CdnIcon icon="Info/Item Paid" />
		},
		[Sorting.Departure]: {
			label: i18n.t('Results:Departure time'),
			icon: <CdnIcon icon="Flight/Takeoff" />
		},
		[Sorting.FlightTime]: {
			label: i18n.t('Results:Flight time'),
			icon: <CdnIcon icon="Info/Time" />
		},
		[Sorting.Arrival]: {
			label: i18n.t('Results:Arrival'),
			icon: <CdnIcon icon="Flight/Land" />
		}
	};

	return sortingLabels[sorting];
};

export const useSortings = (currentSort: Sorting) => {
	const _getSortingOption = (sorting: Sorting): ListOption => ({
		value: String(sorting),
		dataSort: Sorting[sorting],
		...getSortingLabels(sorting)
	});

	const sortingOptions = useMemo(() => sortings.map(_getSortingOption), []);
	const currentSorting = _getSortingOption(currentSort);

	return {
		currentSorting,
		sortingOptions
	};
};
